export default __webpack_public_path__ + "static/media/conditions.3c2f780b.jpeg";